export const teamList = '/account-history/api/account/:id/team-member';
export const teamUserDetail = '/account-history/api/account/:id/team-member/:teamMemberId';
export const teamUserProperties = '/account-history/api/account/:id/team-member/:teamMemberId/property';
export const teamUserUnassignedProperties = '/account-history/api/account/:id/team-member/:teamMemberId/unassigned-property';
export const teamUserPropertyAdd = '/property/account/:account/property/:property_id/team-member';
export const teamUserPropertyRemove = '/property/account/:id/property/:property_id/team-member/:team_member_id';
export const teamUserRemove = '/property/account/:account/team-member/:id';
export const changeRole = '/property/account/:account/team-member/:id/change-role';
export const teamInviteUser = '/property/account/:account/team-member/invite';
export const teamInviteUserSendEmail = '/property/account/:account/team-member/:teamMemberId/resend-invitation';
export const teamTransferOwnership = '/property/account/:account/change-owner';
